import type { AnimationControls } from 'framer-motion';
import { motion } from 'framer-motion';

import { type AnimatedIconHandle, withAnimatedIcon } from './withAnimatedIcon';

type RefreshIconRenderProps = {
  controls: AnimationControls;
  size: number;
};

const RefreshIconRender = ({ controls, size }: RefreshIconRenderProps) => (
  <motion.svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    animate={controls}
    variants={{
      normal: {
        rotate: 0,
      },
      animate: {
        rotate: 360,
        transition: {
          duration: 0.6,
          ease: 'easeInOut',
        },
      },
    }}
  >
    <path
      d="M3.5 7.25C3.6837 7.25002 3.861 7.31746 3.99828 7.43953C4.13556 7.5616 4.22326 7.72981 4.24475 7.91225L4.25 8V8.75C4.24996 9.91428 4.70117 11.0333 5.50885 11.8719C6.31652 12.7104 7.41778 13.2033 8.58125 13.247L8.75 13.25H11.4395L10.8448 12.6552C10.7102 12.5203 10.6321 12.3392 10.6263 12.1487C10.6205 11.9582 10.6874 11.7727 10.8134 11.6298C10.9395 11.4869 11.1152 11.3973 11.3049 11.3792C11.4945 11.3611 11.684 11.4159 11.8348 11.5325L11.9052 11.5947L13.7803 13.4697C13.8933 13.5823 13.9672 13.7282 13.991 13.886L14 14.0075C13.9986 14.1724 13.9427 14.3322 13.841 14.462L13.7772 14.5332L11.9052 16.4052C11.7703 16.5398 11.5892 16.6179 11.3987 16.6237C11.2083 16.6295 11.0227 16.5626 10.8798 16.4366C10.7369 16.3105 10.6473 16.1348 10.6292 15.9451C10.6111 15.7554 10.6659 15.566 10.7825 15.4152L10.8448 15.3447L11.4395 14.75H8.75C7.19118 14.75 5.69356 14.1433 4.57422 13.0584C3.45489 11.9735 2.80171 10.4956 2.753 8.9375L2.75 8.75V8C2.75 7.80108 2.82902 7.61032 2.96967 7.46967C3.11032 7.32902 3.30109 7.25 3.5 7.25ZM7.09475 2.59475C7.22972 2.46024 7.41083 2.38214 7.60129 2.37633C7.79175 2.37051 7.97728 2.43741 8.12021 2.56343C8.26313 2.68946 8.35273 2.86516 8.3708 3.05485C8.38887 3.24455 8.33406 3.434 8.2175 3.58475L8.15525 3.65525L7.5605 4.25H10.25C11.8088 4.25002 13.3064 4.8567 14.4258 5.9416C15.5451 7.0265 16.1983 8.50444 16.247 10.0625L16.25 10.25V11C16.2498 11.1912 16.1766 11.375 16.0454 11.514C15.9141 11.653 15.7348 11.7367 15.544 11.7479C15.3531 11.7591 15.1652 11.697 15.0186 11.5743C14.872 11.4516 14.7778 11.2776 14.7552 11.0877L14.75 11V10.25C14.75 9.08571 14.2988 7.96673 13.4912 7.12814C12.6835 6.28956 11.5822 5.79666 10.4188 5.753L10.25 5.75H7.5605L8.15525 6.34475C8.28976 6.47972 8.36786 6.66082 8.37367 6.85128C8.37949 7.04175 8.31259 7.22728 8.18656 7.37021C8.06054 7.51313 7.88484 7.60273 7.69514 7.6208C7.50545 7.63887 7.31599 7.58406 7.16525 7.4675L7.09475 7.40525L5.21975 5.53025C5.09062 5.4011 5.01304 5.22928 5.00158 5.04701C4.99012 4.86474 5.04556 4.68455 5.1575 4.54025L5.21975 4.46975L7.09475 2.59475Z"
      fill="currentColor"
    />
  </motion.svg>
);

export type RefreshIconHandle = AnimatedIconHandle;

export const RefreshIcon = withAnimatedIcon(RefreshIconRender, 'RefreshIcon');
